import { Typography, Container, Link, Stack } from '@mui/material';

import {
  OrderedListContainer,
  Paragraph,
  ParagraphTitle,
} from '../styled/LicensePage.styled';
import { Layout } from '../components';

const LicensePage = () => {
  return (
    <Layout>
      <Container maxWidth="md">
        <Stack textAlign="justify" gap={3}>
          <Typography variant="h6" textAlign="center" fontWeight={600}>
            ПУБЛІЧНА ЛІЦЕНЗІЯ
          </Typography>
          <Stack gap={1}>
            <Paragraph>
              Зазначене нижче є публічною офертою, що містить усі істотні умови
              Договору публічної ліцензії на використання компʼютерної програми
              «AXELS CHAT» (далі – Договір) між ТОВ «АКСЕЛЬС» (надалі —
              Ліцензіар) з однієї сторони, та вами (далі — Ліцензіат) з іншої
              сторони, у подальшому разом – Сторони, а кожен окремо — Сторона.
            </Paragraph>
            <Paragraph>
              Ця публічна оферта адресована усім фізичним та юридичним особам,
              що бажають скористатися зазначеними нижче послугами і мають
              технічну можливість одержання таких послуг.
            </Paragraph>
            <Paragraph>
              Реєстрація Ліцензіатом облікового запису на вебсайті&nbsp;
              <Link href="https://chat.axels.dev/">
                https://chat.axels.dev/
              </Link>
              &nbsp;є повним та безумовним прийняттям (акцептом) Ліцензіатом
              усіх умов цієї публічної оферти. Договір вважається укладеним з
              моменту створення Вашого облікового запису на вебсайті&nbsp;
              <Link href="https://chat.axels.dev/">
                https://chat.axels.dev/
              </Link>
              .
            </Paragraph>
          </Stack>
          <Stack>
            <Paragraph>
              Погоджуючись з умовами цієї публічної оферти, Ліцензіат або його
              уповноважений представник, підтверджує і гарантує наступне:
            </Paragraph>
            <ul>
              <li>
                <Typography>
                  Ліцензіат або його уповноважений надав достовірні дані, що
                  ідентифікують Ліцензіата, при реєстрації облікового запису на
                  вебсайті &nbsp;
                  <Link href="https://chat.axels.dev/">
                    https://chat.axels.dev/
                  </Link>
                  .
                </Typography>
              </li>
              <li>
                <Typography>
                  Ліцензіат або його уповноважений представник укладає Договір
                  добровільно, ознайомився з усіма умовами Договору, повністю
                  розуміє усі умови Договору, повністю розуміє значення та
                  наслідки своїх дій щодо укладення та виконання Договору.
                </Typography>
              </li>
              <li>
                <Typography>
                  Ліцензіат володіє всіма правами і повноваженнями, необхідними
                  для укладення та виконання Договору. Якщо фізична особа
                  приймає умови цієї публічної оферти від імені юридичної особи,
                  то така фізична особа підтверджує, що вона має повноваження
                  укладати договори від імені цієї юридичної особи, і
                  Ліцензіатом за цим Договором є ця юридична особа. Якщо фізична
                  особа, яка приймає умови цієї публічної оферти від імені
                  юридичної особи, не має повноваження укладати договори від
                  імені цієї юридичної особи, то така особа не повинна приймати
                  умови цієї публічної оферти.
                </Typography>
              </li>
              <li>
                <Typography>
                  Ліцензіат не є резидентом Російської Федерації та/або
                  резидентом Республіки Білорусь, а також що на Ліцензіата не
                  розповсюджуються санкції, запроваджені урядами України, ЄС
                  та/або держав-членів ЄС, Великобританії, США.
                </Typography>
              </li>
              <li>
                <Typography>
                  Ліцензіат не знаходиться на території Російської Федерації
                  та/або Республіки Білорусь, та/або тимчасово окупованих
                  територіях України — Автономній Республіці Крим, окремих
                  регіонах Луганської, Донецької, Запорізької та Херсонської
                  областей.
                </Typography>
              </li>
              <li>
                <Typography>
                  Серед учасників, акціонерів, кінцевих бенефіціарних власників
                  та/або осіб, які мають контроль над Ліцензіатом, відсутні
                  резиденти Російської Федерації та/або резидентів Республіки
                  Білорусь, а також що на зазначених осіб та/або їх керівників
                  або членів органів управління не розповсюджуються санкції,
                  впроваджені урядами України, ЄС та/або держав-членів ЄС,
                  Великобританії, США.
                </Typography>
              </li>
            </ul>
          </Stack>
          <Paragraph>
            Якщо будь-що із зазначених підтверджень та гарантій виявиться таким,
            що не відповідає дійсності станом на дату укладення цього Договору,
            або обставини зміняться після укладення Договору таким чином, що
            будь-що із зазначених підтверджень та гарантій перестане відповідати
            дійсності, Ліцензіар має право у визначений Ліцензіаром строк
            видалити обліковий запис Ліцензіара та припинити дію цього Договору
            в односторонньому порядку без відшкодування Ліцензіату будь-яких
            витрат та збитків, шляхом повідомлення про це Ліцензіата в письмовій
            електронній формі.
          </Paragraph>
          <Stack>
            <ParagraphTitle variant="h6">ОСНОВНІ ПОНЯТТЯ</ParagraphTitle>
            <Paragraph>
              Сторони домовилися, що терміни, які вживаються в цьому Договорі,
              вони розуміють в такому значенні:
            </Paragraph>
            <Paragraph>
              <b>Програмне забезпечення</b> – компʼютерна програма «AXELS CHAT»,
              що представляє собою комплекс програмного забезпечення, що надає
              Ліцензіату on-line функціонал із генерування програмного коду
              Ліцензіатом для будь-якого оточення і мови програмування, її перші
              версії та всі подальші версії, усі подальші зміни, додатки,
              застосунки, доповнення та оновлення до них, які представлені в
              об'єктивній формі сукупністю даних і команд, у тому числі
              вихідного тексту, баз даних, візуальних та аудіо творів, інших
              компонентів, включених до складу зазначеної комп’ютерної програми,
              а також будь-яка документація щодо роботи цієї комп’ютерної
              програми.
            </Paragraph>
            <Paragraph>
              <b>Контент</b> - будь-яка інформація, згенерована Програмним
              забезпеченням під час його використання та на запит Ліцензіата, у
              тому числі інформація у вигляді вихідного та об’єктного коду,
              майнові права особливого роду (sui generis), на який належать
              Ліцензіару у повному складі.
            </Paragraph>
            <Paragraph>
              <b>Адаптований Контент</b> – Контент, опрацьований Ліцензіаром на
              запит Ліцензіата з використанням власної творчої праці авторів –
              працівників та підрядників Ліцензіара, незалежно від обсягів
              такого опрацювання, виключні майнові права інтелектуальної
              власності на який належать Ліцензіару у повному складі.
            </Paragraph>
            <Paragraph>
              <b>Права</b> – виключні майнові авторські права на використання
              Адаптованого Контенту, що надаються Ліцензіату за цим Договором,
              на умовах і в обсязі, зазначеному в Договорі.
            </Paragraph>
            <Paragraph>
              <b>Територія</b> – територія, на яку поширюються надані за цим
              Договором Права, а саме територія України.
            </Paragraph>
            <Paragraph>
              <b>Строк</b> – період часу, на який Ліцензіату надаються Права,
              передбачені в цьому Договорі, а саме увесь строк чинності майнових
              прав інтелектуальної власності на Адаптований Контент.
            </Paragraph>
            <Paragraph>
              <b>Послуги</b> – послуги Ліцензіара, що надаються згідно умов
              цього Договору та полягають у наданні Ліцензіату доступу до
              Програмного забезпечення з метою генерування Контенту, а також
              здійснення його подальшої адаптації Ліцензіаром з використанням
              власної творчої праці авторів – працівників та підрядників
              Ліцензіара з метою створення Адаптованого Контенту на запит
              Ліцензіата.
            </Paragraph>
            <Paragraph>
              <b>Ліцензіар</b> – товариство з обмеженою відповідальністю
              «АКСЕЛЬС», ідентифікаційний код юридичної особи 43454670,
              місцезнаходження: Україна, 01135, місто Київ, вулиця Андрющенка
              Григорія, будинок 4Б, квартира 145.
            </Paragraph>
          </Stack>
          <OrderedListContainer>
            <ol>
              <li>
                <b>ПОСЛУГИ</b>
                <ol>
                  <li>
                    Ліцензіар надає Ліцензіату Послуги у вигляді доступу до
                    Програмного забезпечення з метою генерування Контенту, а
                    також здійснення його подальшої адаптації з використанням
                    власної творчої праці авторів – працівників та підрядників
                    Ліцензіара з метою створення Адаптованого Контенту на запит
                    Ліцензіата на умовах цього Договору.
                  </li>
                  <li>
                    Доступ до Програмного забезпечення здійснюється за допомогою
                    мережі Інтернет через та мобільні застосунки або інші
                    програми, що використовують вебпротоколи.
                  </li>
                  <li>
                    Ліцензіат отримує доступ до Програмного забезпечення шляхом
                    реєстрації та створення облікового запису на вебсайті&nbsp;
                    <Link href="https://chat.axels.dev/">
                      https://chat.axels.dev/
                    </Link>
                    .
                  </li>
                  <li>
                    Ліцензіат отримує доступ до Програмного забезпечення
                    автоматично після створення облікового запису на
                    вебсайті&nbsp;
                    <Link href="https://chat.axels.dev/">
                      https://chat.axels.dev/
                    </Link>
                    .
                  </li>
                  <li>
                    Ліцензіар має право змінювати умови надання послуг на
                    власний розсуд у будь-який час шляхом опублікування нових
                    редакцій публічної оферти планів на вебсайті&nbsp;
                    <Link href="https://chat.axels.dev/">
                      https://chat.axels.dev/
                    </Link>
                    .
                  </li>
                </ol>
              </li>
              <li>
                <b>ПРАВА ІНТЕЛЕКТУАЛЬНОЇ ВЛАСНОСТІ</b>
                <ol>
                  <li>
                    <b>
                      Майнові права інтелектуальної власності на Програмне
                      забезпечення:
                    </b>
                    <ol>
                      <li>
                        Ліцензіар є власником виключних майнових прав на
                        Програмное забезпечення. Ліцензіар підтверджує, що
                        володіє необхідним обсягом виключних майнових прав
                        інтелектуальної власності на Програмне забезпечення для
                        надання доступу до Програмного забезпечення та виконання
                        цього Договору.
                      </li>
                      <li>
                        Доступ Ліцензіата до Програмного забезпечення
                        здійснюється без надання Ліцензіату копії Програмного
                        забезпечення.
                      </li>
                      <li>
                        Згідно із цим Договором Ліцензіат не набуває жодних
                        виключних майнових прав інтелектуальної власності на
                        Програмне забезпечення, включаючи право відтворювати,
                        тобто здійснювати виготовлення примірників (копій)
                        Програмного забезпечення в будь-якій формі, змінювати,
                        розповсюджувати, публічно демонструвати чи публічно
                        показувати Програмне забезпечення, яке використовується
                        для надання Послуг, або будь-яких інших прав щодо
                        Програмного забезпечення, які прямо не вказані у цьому
                        Договорі. Ліцензіар зберігає за собою всі виключні
                        майнові права на Програмне забезпечення, яке
                        використовується для надання Послуг.
                      </li>
                      <li>
                        Вихідні коди Програмного забезпечення (в тому числі їх
                        частини) та алгоритми його роботи є комерційною
                        таємницею Ліцензіара, доступ до якої заборонений
                        Ліцензіату та третім особам.
                      </li>
                      <li>
                        Будь-які дії Ліцензіата щодо Програмного забезпечення,
                        які прямо не дозволені в цьому Договорі, є забороненими,
                        та їх вчинення Ліцензіатом є порушенням виключних
                        майнових прав інтелектуальної власності Ліцензіара на
                        Програмне забезпечення, що є достатньою підставою для
                        розірвання цього Договору та/або вжиття заходів захисту
                        порушених прав та законних інтересів Ліцензіара.
                      </li>
                    </ol>
                  </li>
                  <li>
                    <b>
                      Майнові права особливого роду (sui generis) на Контент:
                    </b>
                    <ol>
                      <li>
                        Ліцензіар є власником майнових прав особливого роду (sui
                        generis) на Контент. Ліцензіар підтверджує, що володіє
                        необхідним обсягом майнових прав особливого роду (sui
                        generis) на Контент для виконання цього Договору.
                      </li>
                      <li>
                        Згідно із цим Договором Ліцензіат не набуває жодних
                        майнових прав особливого роду (sui generis) на Контент,
                        включаючи право відтворювати, тобто здійснювати
                        виготовлення примірників (копій) Контенту в будь-якій
                        формі, змінювати, розповсюджувати, публічно
                        демонструвати чи публічно показувати Контент, який
                        використовується для надання Послуг, або будь-яких інших
                        прав щодо Контенту, які прямо не вказані у цьому
                        Договорі, крім випадків вільного використання обʼєктів
                        права особливого роду (sui generis), визначених законом.
                        Ліцензіар зберігає за собою усі майнові права особливого
                        роду (sui generis) на Контент, який використовується для
                        надання Послуг.
                      </li>
                      <li>
                        Будь-які дії Ліцензіата щодо Контенту, які прямо не
                        дозволені в цьому Договорі, є забороненими, та їх
                        вчинення Ліцензіатом є порушенням майнових прав
                        особливого роду (sui generis) на Контент, що є
                        достатньою підставою для розірвання цього Договору
                        та/або вжиття заходів захисту порушених прав та законних
                        інтересів Ліцензіара.
                      </li>
                    </ol>
                  </li>
                  <li>
                    <b>Виключні майнові права на Адаптований Контент:</b>
                  </li>
                  <li>
                    Ліцензіар є власником виключних майнових прав на Адаптований
                    Контент.
                  </li>
                  <li>
                    Ліцензіар надає Ліцензіату Права на використання
                    Адаптованого Контенту наступними способами:
                    <ol>
                      <li>відтворення Адаптованого Контенту;</li>
                      <li>
                        включення Адаптованого Контенту до складеного твору;
                      </li>
                      <li>
                        включення Адаптованого Контенту до іншого твору, крім
                        складеного твору;
                      </li>
                      <li>розповсюдження примірників Адаптованого Контенту;</li>
                      <li>імпорт примірників Адаптованого Контенту;</li>
                      <li>
                        здавання в найм або в позичку примірників Адаптованого
                        Контенту;
                      </li>
                      <li>
                        публічне виконання, публічний показ, публічне
                        демонстрування, публічне сповіщення, інтерактивне
                        надання доступу публіці та інші способи доведення до
                        загального відома публіки Адаптованого Контенту;
                      </li>
                      <li>переклад Адаптованого Контенту;</li>
                      <li>
                        переробка, адаптація, аранжування та інші подібні зміни
                        Адаптованого Контенту.
                      </li>
                    </ol>
                  </li>
                  <li>
                    Права за цим Договором надаються Ліцензіату протягом Строку,
                    в межах Території, на умовах безвідкличної невиключної
                    ліцензії.
                  </li>
                  <li>
                    За цим Договором Ліцензіату не передаються (не відчужуються)
                    майнові авторські права на Адаптований Контент, а тому
                    Ліцензіат не має права продати або іншим способом відчужити
                    майнові права інтелектуальної власності на Адаптований
                    контент.
                  </li>
                  <li>
                    Ліцензіат не має права надавати третім особам Права на
                    використання Адаптованого Контенту (видавати субліцензії).
                  </li>
                  <li>
                    Права на Адаптований Контент надаються Ліцензіату з моменту
                    передання Ліцензіату Адаптованого Контенту, що здійснюється
                    шляхом шляхом підписання акту наданих послуг.
                  </li>
                </ol>
              </li>
              <li>
                <b>ДОСТУП ДО ПРОГРАМНОГО ЗАБЕЗПЕЧЕННЯ</b>
                <ol>
                  <li>
                    Для доступу до Програмного забезпечення Ліцензіату необхідно
                    створити обліковий запис шляхом реєстрації на вебсайті&nbsp;
                    <Link href="https://chat.axels.dev/">
                      https://chat.axels.dev/
                    </Link>
                    .
                  </li>
                  <li>
                    Ліцензіат погоджується з тим, що у разі створення облікового
                    запису фізичною особою від імені юридичної особи, така особа
                    вважається наділеною повноваженнями на вчинення від імені
                    юридичної особи всіх юридичних та фактичних дій (у тому
                    числі на прийняття умов цього Договору), та її дії в
                    обліковому записі визнаються діями безпосередньо юридичної
                    особи Ліцензіата. Будь-які та усі питання доступу до
                    облікового запису вирішуються виключно Ліцензіатом та його
                    представником.
                  </li>
                  <li>
                    Під час реєстрації Ліцензіат зобов'язаний заповнити форму
                    реєстрації та надати достовірну інформацію про себе і
                    підтримувати цю інформацію в актуальному стані.
                  </li>
                  <li>
                    Під час реєстрації Ліцензіат самостійно визначає логін
                    (унікальне ім'я) у вигляді адреси електронної пошти та
                    самостійно створює пароль для доступу до Програмного
                    забезпечення з подальшим створенням облікового запису для
                    взаємодії з Програмним забезпеченням.
                  </li>
                  <li>
                    Ліцензіар має право забороняти використання певних
                    найменувань облікових записів, а також встановлювати вимоги
                    до логіну та паролю (довжина, допустимі символи тощо).
                  </li>
                  <li>
                    Ідентифікація Ліцензіата здійснюється на підставі адреси
                    електронної пошти, вказаної Ліцензіатом в якості логіну під
                    час реєстрації. Ліцензіат зобов’язаний вказати адресу
                    електронної пошти, що перебуває у його безумовному доступі
                    та користуванні.
                  </li>
                  <li>
                    Якщо Ліцензіат надає недостовірну інформацію, або у
                    Ліцензіара є підстави вважати, що надана їм інформація є
                    неповною або недостовірною, Ліцензіар має право заблокувати
                    або видалити обліковий запис Ліцензіата.
                  </li>
                  <li>
                    Ліцензіат самостійно несе відповідальність за безпеку
                    (стійкість до вгадування) вибраного ним пароля, а також
                    самостійно забезпечує конфіденційність свого пароля.
                  </li>
                  <li>
                    Ліцензіат самостійно несе відповідальність за всі діяння
                    (дії або бездіяльність), які вчинені з використанням
                    облікового запису Ліцензіата, включаючи випадки добровільної
                    передачі або недотримання конфіденційності даних для доступу
                    до облікового запису Ліцензіата третім особам на будь-яких
                    умовах (у тому числі на підставі договорів). При цьому всі
                    дії щодо використанням Програмного забезпечення з
                    використанням облікового запису Ліцензіата вважаються
                    вчиненими самим Ліцензіатом, за винятком випадків отримання
                    Ліцензіаром повідомлення від Ліцензіата, направленого в
                    порядку, передбаченому цим Договором, про несанкціонований
                    доступ до Програмного забезпечення з використанням
                    облікового запису Ліцензіата або про будь-які порушення
                    (підозру про порушення) конфіденційності пароля Ліцензіата.
                  </li>
                  <li>
                    Ліцензіат зобов'язаний негайно повідомити Ліцензіара про
                    будь-які випадки несанкціонованого доступу до Програмного
                    забезпечення з використанням облікового запису Ліцензіата
                    та/або про будь-які порушення (підозру про порушення)
                    конфіденційності свого пароля.
                  </li>
                  <li>
                    Ліцензіар не несе відповідальність відповідає за втрату
                    даних Ліцензіата, а також інші наслідки будь-якого
                    характеру, які можуть виникнути через порушення Ліцензіатом
                    положень Договору.
                  </li>
                </ol>
              </li>
              <li>
                <b>ОПЛАТА</b>
                <ol>
                  <li>
                    За використання Прав на Адаптований Контент способами,
                    передбаченими цим Договором, Ліцензіат зобов'язується
                    виплачувати Ліцензіару винагороду (роялті) в розмірі 10
                    гривень за кожен рядок Адаптованого Контенту.
                  </li>
                  <li>
                    Виплата винагороди (роялті) здійснюється в гривні, у
                    безготівковому порядку, шляхом перерахування Ліцензіатом
                    грошових коштів на розрахунковий рахунок Ліцензіара протягом
                    5 (пʼяти) банківських з моменту виставлення Ліцензіату
                    відповідного рахунку, який надсилається Ліцензіату разом із
                    переданням Адаптованого Контенту. / шляхом безготівкового
                    платежу способами, які доступні на вебсайті&nbsp;
                    <Link href="https://chat.axels.dev/">
                      https://chat.axels.dev/
                    </Link>
                    &nbsp;протягом 5 (пʼяти) банківських з моменту виставлення
                    Ліцензіату відповідного рахунку, який надсилається
                    Ліцензіату разом із переданням Адаптованого Контенту.
                  </li>
                  <li>
                    Зобов’язання Ліцензіата щодо виплати винагороди (роялті)
                    вважається виконаним з моменту списання грошових коштів з
                    поточного рахунку Ліцензіата. Всі витрати, пов’язані з
                    переказом коштів, покладаються на Ліцензіата.
                  </li>
                </ol>
              </li>
              <li>
                <b>ПІДТВЕРДЖЕННЯ НАДАННЯ ПРАВ</b>
                <ol>
                  <li>
                    На вимогу Ліцензіата з метою підтвердження факту належного
                    надання Ліцензіаром Прав Сторони можуть складати відповідні
                    акти в електронній формі за допомогою системи електронного
                    документообігу.
                  </li>
                </ol>
              </li>
              <li>
                <b>ТЕХНІЧНА ТА КОНСУЛЬТАЦІЙНА ПІДТРИМКА</b>
                <ol>
                  <li>
                    Ліцензіат має право на отримання від Ліцензіара технічної та
                    консультаційної підтримки з питань, пов'язаних з
                    функціонуванням Програмного забезпечення згідно умов цього
                    Договору.
                  </li>
                  <li>
                    Для здійснення технічної та консультаційної підтримки
                    Ліцензіар має право вимагати від Ліцензіата надання
                    інформації щодо даних облікового запису, технічних
                    характеристик обладнання та іншу необхідну інформацію.
                  </li>
                  <li>
                    Для забезпечення технічної та консультаційної підтримки
                    Ліцензіар має право залучати третіх осіб.
                  </li>
                </ol>
              </li>
              <li>
                <b>СТРОК ДОГОВОРУ. ПРИПИНЕННЯ ДОГОВОРУ</b>
                <ol>
                  <li>
                    Цей Договір є укладеним з моменту створення облікового
                    запису Ліцензіата на вебсайті&nbsp;
                    <Link href="https://chat.axels.dev/">
                      https://chat.axels.dev/
                    </Link>
                    .
                  </li>
                  <li>
                    Цей договір діє з моменту укладення доки його не буде
                    припинено у порядку, визначеному в цьому розділі Договору.
                  </li>
                  <li>
                    Ліцензіат має право видалити свій обліковий запис. У цьому
                    випадку Договір припиняється з моменту видалення Ліцензіатом
                    облікового запису.
                  </li>
                  <li>
                    Ліцензіар має право призупинити надання доступу до
                    Програмного забезпечення на визначений Ліцензіатом строк або
                    видалити обліковий запис Ліцензіара та припинити дію цього
                    Договору в односторонньому порядку у визначений Ліцензіаром
                    строк без відшкодування Ліцензіату будь-яких витрат та
                    збитків, шляхом повідомлення про це Ліцензіата в письмовій
                    електронній формі з таких підстав:
                    <ol>
                      <li>
                        здійснення Ліцензіатом або будь-яким користувачем
                        Ліцензіата дій, які на думку Ліцензіара (а) становлять
                        загрозу безпеці функціонування Програмного забезпечення
                        або (б) можуть призвести до відповідальності Ліцензіара,
                        або (в) є або можуть бути шахрайським (г) порушують
                        чинне законодавство;
                      </li>
                      <li>
                        Ліцензіатом або будь-яким користувачем Ліцензіата
                        порушено будь-яке положення цього Договору;
                      </li>
                      <li>
                        розголошення Ліцензіатом або будь-яким користувачем
                        Ліцензіата конфіденційної інформації третім особам
                        незалежно від наявності або відсутності у Ліцензіара
                        фактичних збитків, спричинених таким розголошенням;
                      </li>
                      <li>
                        несанкціонований доступ Ліцензіатом або будь-яким
                        користувачем Ліцензіата до комерційної таємниці
                        Ліцензіара;
                      </li>
                      <li>
                        порушення Ліцензіатом або будь-яким користувачем
                        Ліцензіата підтверджень та гарантій, наданих при
                        укладанні цього Договору;
                      </li>
                      <li>
                        припинення або зміна умов надання Ліцензіару третіми
                        сторонами стороннього програмного забезпечення, сервісів
                        та технологій, що використовуються для функціонування
                        Програмного забезпечення;
                      </li>
                      <li>
                        здійснення Ліцензіатом доступу до Програмного
                        забезпечення у заборонених законом цілях або в цілях,
                        які порушують права третіх осіб;
                      </li>
                      <li>
                        зміна чинного законодавства або нормативно-правових
                        актів державних органів, що впливають на Ліцензіара
                        та/або його афілійованих осіб, у зв'язку з чим
                        забезпечення доступу до Програмного забезпечення стає
                        неможливим або надмірно утрудненим;
                      </li>
                      <li>
                        Ліцензіатом не використовується Програмне забезпечення
                        та не було здійснено доступу до облікового запису
                        протягом 180 днів безперервно.
                      </li>
                    </ol>
                  </li>
                  <li>
                    Наслідки припинення Договору:
                    <ol>
                      <li>
                        припинення доступу Ліцензіата до Програмного
                        забезпечення;
                      </li>
                      <li>
                        припинення прав та обов’язків Сторін, окрім зобов’язань,
                        зазначених у розділах 2, 10 - 12, 14 цього Договору;
                      </li>
                      <li>
                        усі дані облікового запису та Контент, згенерований
                        Програмним забезпеченням на запит Ліцензіата, які
                        перебувають у володінні або контролі Ліцензіара, можуть
                        бути видалені Ліцензіаром без можливості відновлення,
                        окрім випадків, коли збереження таких даних вимагається
                        законодавством.
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
              <li>
                <b>ЗМІНА ДОГОВОРУ</b>
                <ol>
                  <li>
                    Ліцензіар має право вносити будь-які зміни та доповнення до
                    цього Договору в односторонньому порядку в будь-який час без
                    будь-якого спеціального повідомлення, розмістивши нову
                    редакцію цього Договору на вебсторінці&nbsp;
                    <Link href="https://chat.axels.dev/">
                      https://chat.axels.dev/
                    </Link>
                    . редакція Договору набуває чинності з моменту її розміщення
                    на вебсторінці&nbsp;
                    <Link href="https://chat.axels.dev/">
                      https://chat.axels.dev/
                    </Link>
                    , якщо інше не передбачено новою редакцією Договору.
                  </li>
                  <li>
                    Ліцензіат зобов’язується періодично переглядати актуальну
                    редакцію Договору. Якщо після спливу 5 (п'яти) календарних
                    днів після розміщення нової редакції Договору на вебсторінці{' '}
                    <Link href="https://chat.axels.dev/">
                      https://chat.axels.dev/
                    </Link>
                    &nbsp;Ліцензіат не видалив свій обліковий запис, це означає,
                    що Ліцензіат повністю і беззастережно погоджується на
                    надання йому доступу до Програмного забезпечення на
                    відповідних змінених або доповнених умовах Договору.
                  </li>
                </ol>
              </li>
              <li>
                <b>ЗАМІНА СТОРОНИ В ДОГОВОРІ</b>
                <ol>
                  <li>
                    Ліцензіат має право передати повністю свої права та
                    обов'язки за Договором іншій особі (новому Ліцензіату) лише
                    за умови отримання письмової згоди Ліцензіара. Передача прав
                    та обов'язків здійснюється лише за умови повної та
                    беззастережної згоди нового Ліцензіара з усіма положеннями
                    та умовами цього Договору. Ліцензіат зобов'язаний надати
                    Ліцензіару повні та достовірні дані про нового Ліцензіата,
                    для перереєстрації облікового запису Ліцензіата на нового
                    Ліцензіата.
                  </li>
                  <li>
                    Ліцензіар має право передати свої права та обов'язки за цим
                    Договором третій особі (Правонаступнику). Погоджуючись з
                    умовами цього Договору, Ліцензіат надає свою попередню згоду
                    на таку передачу прав в обсязі та на умовах, які
                    існуватимуть на момент заміни Ліцензіара в Договорі.{' '}
                  </li>
                </ol>
              </li>
              <li>
                <b>ВІДПОВІДАЛЬНІСТЬ</b>
                <ol>
                  <li>
                    Сторони несуть відповідальність за невиконання або неналежне
                    виконання своїх зобов'язань за цим Договором згідно із цим
                    Договором та законодавством.
                  </li>
                  <li>
                    Доступ до Програмного забезпечення надається відповідно до
                    загальноприйнятого у світовій практиці принципу «як є» (As
                    Is). Ліцензіар не гарантує, що функціональні можливості
                    Програмного забезпечення, Контент та Адаптований Контент
                    відповідатимуть очікуванням Ліцензіата та зможуть бути
                    застосовані для конкретної мети Ліцензіата.
                  </li>
                  <li>
                    Ліцензіар не несе відповідальності перед Ліцензіатом за
                    затримки та перебої в роботі Програмного забезпечення, що
                    відбуваються прямо чи опосередковано з причин, що
                    знаходиться поза сферою розумного контролю з боку
                    Ліцензіара.
                  </li>
                  <li>
                    Ліцензіат погоджується, що для функціонування Програмного
                    забезпечення використовується програмне забезпечення та
                    обладнання, та послуги третіх осіб, і Ліцензіар не несе
                    відповідальності за якість послуг та робіт цих третіх осіб.
                  </li>
                  <li>
                    Ліцензіат погоджується з тим, що Програмне забезпечення може
                    містити помилки. Якщо під час використання Програмного
                    забезпечення будуть виявлені помилки, Ліцензіар вживатиме
                    заходи для їх виправлення у максимально короткі строки.
                    Сторони погоджуються, що точне визначення строку усунення
                    помилки неможливо встановити, оскільки Програмне
                    забезпечення тісно взаємодіє з програмами сторонніх
                    розробників, і працездатність та час усунення проблеми
                    повною мірою не залежать від Ліцензіара.
                  </li>
                  <li>
                    Ліцензіат погоджується з тим, що будь-яке використання
                    Адаптованого Контенту, включаючи інтегрування Адаптованого
                    Контенту у будь-яке програмне забезпечення та використання
                    такого програмного забезпечення, здійснюється ним на свій
                    власний розсуд і ризик. Ліцензіар не контролює зміст,
                    якість, відповідність законодавству та очікуванням
                    Ліцензіата Адаптованого Контенту та програмного
                    забезпечення, створеного шляхом інтегрування у нього
                    Адаптованого Контенту. Ліцензіар не несе відповідальності за
                    зміст та результати інтегрування Адаптованого Контенту у
                    будь-яке програмне забезпечення та його подальше
                    використання, в тому числі за функціональні можливості
                    Адаптованого Контенту після його інтегрування у будь-яке
                    програмне забезпечення. Ліцензіар не несе відповідальності
                    за шкоду, заподіяну використанням або неможливістю
                    використання Адаптованого Контенту та будь-якого програмного
                    забезпечення, створеного шляхом інтеграції у нього
                    Адаптованого Контенту.
                  </li>
                  <li>
                    Ліцензіар не несе відповідальності перед Ліцензіатом за
                    втрачений прибуток або вигоду, або за збитки через втрату
                    доступу до Програмного забезпечення або можливості
                    використовувати Програмне забезпечення, або переривання
                    господарської діяльності Ліцензіата, незалежно від причин і
                    підстав виникнення таких збитків.
                  </li>
                </ol>
              </li>
              <li>
                <b>ФОРС-МАЖОР</b>
                <ol>
                  <li>
                    Сторони звільняються від відповідальності за затримку,
                    прострочення або невиконання будь-яких зобов’язань за цим
                    Договором, якщо таке невиконання є наслідком дії обставин
                    непереборної сили (форс-мажорні обставини), що виникли після
                    укладання Договору.
                  </li>
                  <li>
                    Обставинами непереборної сили (форс-мажорні обставини) є
                    встановлені законом надзвичайні та невідворотні обставини,
                    що об'єктивно унеможливлюють виконання зобов'язань,
                    передбачених умовами цього Договору.
                  </li>
                  <li>
                    У випадку виникнення обставин непереборної сили
                    (форс-мажорні обставини), строки виконання Сторонами
                    зобов’язань за цим Договором продовжуються на строк дії
                    таких обставин.
                  </li>
                </ol>
              </li>
              <li>
                <b>КОНФІДЕНЦІЙНА ІНФОРМАЦІЯ</b>
                <ol>
                  <li>
                    Конфіденційна інформація означає всю інформацію, розкриту
                    однією Стороною Договору іншій Стороні, яка є відомою
                    обмеженому колу осіб (не перебуває у публічному доступі), та
                    відповідає хоча би одній із наступних ознак:
                    <ol>
                      <li>позначена як конфіденційна; або</li>
                      <li>
                        обґрунтовано може вважатися комерційною таємницею або
                        конфіденційною інформацією, незалежно від того, чи
                        позначено її як конфіденційну інформацію або комерційну
                        таємницю; або
                      </li>
                      <li>
                        клієнтські бази даних, договори, рахунки, банківська та
                        фінансова інформація, бізнес-плани, маркетингові плани,
                        технологія та технічна інформацію, інформація про
                        об’єкти інтелектуальної власності, інформація про бізнес
                        процеси.
                      </li>
                    </ol>
                  </li>
                  <li>
                    Конфіденційна інформація не включає:
                    <ol>
                      <li>
                        відомості, які є або стають загальновідомими, або
                        перебувають у публічному доступі з причин, які не
                        пов’язані з діями або бездіяльністю Сторони цього
                        Договору;
                      </li>
                      <li>
                        інформація, надана третім особам за попереднім письмовим
                        дозволом Сторони цього Договору;
                      </li>
                      <li>
                        відомості, розкриття яких є необхідним відповідно до
                        вимог чинного законодавства. Такі відомості можуть бути
                        надані тільки до органів або установ, належним чином
                        уповноважених на витребування та отримання
                        конфіденційної інформації, у порядку, передбаченому
                        чинним законодавством.
                      </li>
                    </ol>
                  </li>
                  <li>
                    Сторони зобов'язуються не передавати та не розголошувати
                    третім особам конфіденційну інформацію без попереднього
                    письмового дозволу одна одної протягом усього строку дії
                    Договору, а також протягом 5 (п'яти) років після закінчення
                    дії Договору. Розголошення конфіденційної інформації
                    означає, не обмежуючись, такі дії: опублікування її у пресі,
                    передання по радіо, телебаченню чи з використанням інших
                    засобів масової інформації; поширення в мережі Інтернет або
                    з використанням інших засобів телекомунікаційного зв`язку;
                    викладення в заявах, листах, адресованих третім особам,
                    повідомлення в публічних виступах, в електронних соціальних
                    мережах; інші дії, які призводять до доступу третіх осіб до
                    конфіденційної інформації.
                  </li>
                  <li>
                    Сторона, яка одержала конфіденційну інформацію, зобов’язана
                    вживати належних та достатніх заходів для забезпечення її
                    конфіденційності.
                  </li>
                  <li>
                    Сторона, яка одержала конфіденційну інформацію,
                    зобов’язується не використовувати конфіденційну інформацію з
                    будь-якою іншою метою, окрім як для забезпечення виконання
                    цього Договору.
                  </li>
                  <li>
                    Сторона, яка одержала конфіденційну інформацію,
                    зобов’язується не розголошувати конфіденційну інформацію
                    будь-якому своєму співробітнику або підряднику, окрім
                    випадків, коли співробітник або підрядник потребує доступу
                    до конфіденційної інформації в цілях забезпечення виконання
                    цього Договору за умови наявності письмової угоди про
                    нерозголошення конфіденційної інформації з таким
                    співробітником або підрядником.
                  </li>
                  <li>
                    Ліцензіат погоджується з правом Ліцензіара агрегувати,
                    систематизувати та аналізувати отриману від Ліцензіата
                    інформацію, після знеособлення цієї інформації, у тому числі
                    конфіденційної, з метою створення інформаційно-аналітичних
                    звітів різного роду та баз даних. Ліцензіар гарантує
                    нерозповсюдження та збереження конфіденційної інформації, що
                    міститься у звітах та базах даних відповідно до цього
                    Договору та чинного законодавства. Власником виключних
                    майнових прав на такі інформаційно-аналітичні звіти та бази
                    даних, як на об'єкти інтелектуальної власності, є Ліцензіар.
                  </li>
                </ol>
              </li>
              <li>
                <b>КОНТЕНТ</b>
                <ol>
                  <li>
                    Ліцензіат несе повну відповідальність за зміст, безпечність
                    та відповідність Контенту законодавству та погоджується, що
                    Ліцензіар не контролює і не перевіряє Контент. Ліцензіат
                    погоджується, що він несе виключну відповідальність за весь
                    Контент, який згенеровано на запит Ліцензіара Програмним
                    забезпеченням, або який зберігається у обліковому записі
                    Ліцензіата.
                  </li>
                  <li>
                    Ліцензіат має право завантажувати та зберігати в обліковому
                    записі Контент, загальний об’єм якого не перевищує
                    максимальний показник, передбачений Ліцензіаром.
                  </li>
                  <li>
                    Ліцензіар здійснює регулярне резервне копіювання Контенту
                    Ліцензіата, включаючи персональні дані. Ліцензіат
                    погоджується, що, незважаючи на резервне копіювання
                    Контенту, Ліцензіар не гарантує збереження, цілісність та не
                    пошкодженість Контенту, згенерованого на запит Ліцензіата.
                    Пошкодження Контенту, згенерованого на запит Ліцензіата,
                    може виникнути, зокрема, до резервного копіювання або під
                    час виконання резервного копіювання. Ліцензіар може
                    намагатись усунути будь-які відомі чи виявлені проблеми, які
                    можуть вплинути на резервне копіювання Контенту. При цьому
                    Ліцензіат визнає, що Ліцензіар не несе відповідальності за
                    цілісність Контенту або неможливість успішного відновлення
                    Контенту до придатного для використання стану. Ліцензіат не
                    має права на копіювання Контенту та зберігання Контенту у
                    місці, незалежному від Ліцензіара.
                  </li>
                </ol>
              </li>
              <li>
                <b>ПРАВО ТА СУД</b>
                <ol>
                  <li>До цього Договору застосовується право України.</li>
                  <li>
                    Усі спори, що виникають з цього Договору або пов'язані із
                    ним, вирішується судами України відповідно до чинного
                    законодавства України.
                  </li>
                </ol>
              </li>
              <li>
                <b>КОНТАКТНА ІНФОРМАЦІЯ</b>
                <ol>
                  <li>
                    Адресами для обміну інформацією та документацією, необхідною
                    для виконання цього договору є:
                    <ol>
                      <li>
                        Для Ліцензіата адреса електронної пошти, вказана
                        Ліцензіатом під час реєстрації облікового запису.
                      </li>
                      <li>
                        Для Ліцензіара
                        <br />
                        адреса електронної пошти Ліцензіара:
                        mike.gusev.js@gmail.com
                        <br /> поштова адреса Ліцензіара: м. Київ, вул.
                        Казарменна 4б, кв. 145, Україна, 01135
                      </li>
                    </ol>
                  </li>
                  <li>
                    Усі повідомлення та документи надсилаються лише за вказаними
                    Сторонами адресами. Ліцензіат несе відповідальність за не
                    отримання будь-яких повідомлень від Ліцензіара у випадку,
                    якщо адреса вказана помилково або змінена, і Ліцензіат не
                    повідомив Ліцензіару нову адресу електронної пошти.
                  </li>
                  <li>
                    Сторони домовилися, що рахунки, акти, додатки, інші первинні
                    документи (за виключенням обмежень, встановлених
                    законодавством) оформлюються в електронній формі за
                    допомогою системи електронного документообігу. У разі
                    надсилання відповідних документів кільком адресатам або їх
                    зберігання на кількох електронних носіях інформації кожний з
                    електронних примірників таких документів вважається
                    оригіналом електронного документа.
                  </li>
                </ol>
              </li>
            </ol>
          </OrderedListContainer>
        </Stack>
      </Container>
    </Layout>
  );
};

export default LicensePage;
